module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_lanche.dc3f0d9c.png";